
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("ember-cached-decorator-polyfill/index", function(){ return i("ember-cached-decorator-polyfill/index");});
d("@ember-decorators/component/index", function(){ return i("@ember-decorators/component/index");});
import "discourse-i18n/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "truth-helpers/-embroider-implicit-modules.js";
import "ember-cached-decorator-polyfill/-embroider-implicit-modules.js";
import "ember-template-imports/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "@ember-decorators/component/-embroider-implicit-modules.js";
import "ember-decorators/-embroider-implicit-modules.js";
